var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "component-card", attrs: { id: "component-list-board" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "list-boards p__r--0",
              staticStyle: { "padding-right": "0" },
              attrs: { id: "list-board", md: "4" }
            },
            [
              _c(
                "b-row",
                { staticClass: "component-header" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "component-title p__t--15",
                      attrs: { cols: "12" }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _c("h3", [_vm._v("BOARD")])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "pr-0", attrs: { cols: "10" } },
                            [
                              _c(
                                "b-form",
                                {
                                  on: {
                                    keyup: function($event) {
                                      if (
                                        !("button" in $event) &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key
                                        )
                                      ) {
                                        return null
                                      }
                                      _vm.searchBoard()
                                    }
                                  }
                                },
                                [
                                  _c("j-input", {
                                    staticClass: "m__r--5",
                                    attrs: { placeholder: "Search" },
                                    model: {
                                      value: _vm.filter_data,
                                      callback: function($$v) {
                                        _vm.filter_data = $$v
                                      },
                                      expression: "filter_data"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              attrs: { cols: "2" },
                              on: { click: _vm.addNewBoard }
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fa fa-plus font-weight-bold cursor-pointer m__t--5"
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-modal",
                        {
                          ref: "modalCreateBoard",
                          staticClass: "mod-form",
                          attrs: { centered: "" }
                        },
                        [
                          _c("h3", [_vm._v("CREATE BOARD")]),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.data_create_board.name.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Board Name* ")]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  "max-length": 255,
                                  placeholder: "Board Name"
                                },
                                model: {
                                  value: _vm.$v.data_create_board.name.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_create_board.name,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression: "$v.data_create_board.name.$model"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.data_create_board.description.$error
                              }
                            },
                            [
                              _c("label", [_vm._v(" Description* ")]),
                              _vm._v(" "),
                              _c("j-textarea", {
                                attrs: {
                                  "max-length": 300,
                                  placeholder: "Description"
                                },
                                model: {
                                  value:
                                    _vm.$v.data_create_board.description.$model,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.$v.data_create_board.description,
                                      "$model",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "$v.data_create_board.description.$model"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c(
                                  "div",
                                  { staticClass: "float-to-right" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btn blue m__r--5",
                                        on: { click: _vm.createBoard }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Create\n                  "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btn gray",
                                        on: { click: _vm.closeCreateBoard }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Close\n                  "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "component-body" },
                _vm._l(_vm.listBoardSetting, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass:
                        "col-12 d-flex justify-content-between\n            component-card cursor-pointer align-items-end",
                      class: { active: _vm.boardIndex === index },
                      on: {
                        click: function($event) {
                          _vm.switchBoard(item, index)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "m__r--10" }, [
                          _c("i", {
                            staticClass:
                              "fa fa-table font-weight-medium cursor-pointer m__t--5"
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("h4", { staticClass: "title-board-component" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "id-board-component" }, [
                            _vm._v("ID: " + _vm._s(item.id))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column align-items-end" },
                        [
                          _c("span", { staticClass: "text-action" }, [
                            _c("b", [_vm._v("View")])
                          ])
                        ]
                      )
                    ]
                  )
                })
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticStyle: { "padding-right": "0" }, attrs: { md: "8" } },
            [
              _vm.board !== null
                ? _c("j-board-setting-detail", {
                    key: _vm.board.id,
                    attrs: { board: _vm.board }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3deda9fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3deda9fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/board/jBoardSetting.vue
// module id = null
// module chunks = 